import { MyLink } from '@ui-kit/Link';
import { Grid } from '@ui-kit/Grid';
import classNames from 'classnames';
import IconPhone from './phone.svg';
import { useAppSelector } from '@redux/hooks';

import styles from './FooterPhone.module.scss';

export const FooterPhone = (): JSX.Element => {
  const { PHONE, FEDERAL_PHONE } = useAppSelector(state => state.header.data.region);
  return (
    <MyLink href={`tel:${PHONE || FEDERAL_PHONE}`} className={classNames(styles.LinkPhone, ' js-calltracking_phone3')}>
      <Grid gap={'8px'} row at>
        <IconPhone />
        <span data-testid="footer-phone">{PHONE || FEDERAL_PHONE}</span>
      </Grid>
    </MyLink>
  );
};
